import React from 'react';
import TableBoolean from '../../../components/Table/TableBoolean/TableBoolean';

const headerStyle = () => {
    return { borderColor: '#a81933' };
};

const columnStyle = () => {
    return { overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' };
};

export const columns = [
    {
        dataField: 'name',
        text: 'Category Name',
        sort: true,
        headerStyle: headerStyle,
        style: columnStyle
    },
    {
        dataField: 'statusName',
        text: 'Status',
        sort: true,
        formatter: (_cell, row) => <TableBoolean value={row.statusId === 1} text={row.statusName} />,
        headerStyle: () => { return { width: '130px', ...headerStyle() }; }
    },
    {
        dataField: 'headerFileUrl',
        text: 'Header Url',
        sort: true,
        headerStyle: headerStyle,
        style: columnStyle
    },
];
    
export const sorting = [{
    dataField: 'name',
    order: 'desc'
}];